module.exports = __webpack_public_path__ + "static/media/zeto.e990b328.png";